export default __webpack_public_path__ + "static/media/autoSuspendedIcon.46b28946.svg";